import VueSession from 'vue-session'
Vue.use(VueSession)

import './store/ml'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'
import VueFormGenerator from "vue-form-generator"
import VueFormWizard from 'vue-form-wizard'
import { mapActions } from 'vuex'



import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import { ValidationObserver, ValidationProvider, extend, configure, localize } from 'vee-validate';
import es from 'vee-validate/dist/locale/es.json';
import * as rules from 'vee-validate/dist/rules';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import VuejsDialog from 'vuejs-dialog'
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import vuetify from './plugins/vuetify';

Vue.use(VuejsDialog)
Vue.use(VuejsDialogMixin)
Vue.use(VueFormWizard)
Vue.use(VueFormGenerator)
Vue.use(BootstrapVue)

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);

localize('es', es);
Object.keys(rules).forEach(rule => { extend(rule, rules[rule]); });
Vue.use(Loading, {color: '#222', backgroundColor: '#fff', loader: 'dots', opacity: 0.6, width: 100, height: 100});
configure({aria: true, classes: { valid: 'is-valid', invalid: 'is-invalid'}})

Vue.config.productionTip = true

new Vue({
  router,
  store,
  render: h => h(App),
  created: function (){ this.callIberoWS(); },
  vuetify,
  methods: { ...mapActions(['callIberoWS']) }
}).$mount('#app');
